import React, { useEffect, useState } from 'react';
import { BuildPath } from '../../../helpers/Paths';
import { SearchBoxProps } from '../../../interfaces/unsplash';

const SearchBox = (props: {data:SearchBoxProps}) => {

    const { submitDisabled, searchBtnClick, onChange , resetSearch, keyword }  = props.data;

    const [resetClick, setResetClick] = useState<boolean>(false);

    const reset = () => {
        onChange("");
        setResetClick(true);
    }

    useEffect(() => {

        if (resetClick && keyword === ""){
            resetSearch(true)
        }
        
    }, [keyword, resetClick]);


    return (
        
            <React.Fragment>
            
                <img style={{height: 25, width: 107}}src={`${BuildPath()}/images/unsplash/unsplashlogo.svg`} alt="Unsplash" />

                <button type="button" disabled={submitDisabled} onClick={searchBtnClick}>Search</button>
                
                <div className="search-input-container">
                    <input type="text"
                        aria-label="Search for images via Unsplash"
                        placeholder="Search for images via Unsplash"
                        value={keyword}
                        onChange={(e) => onChange(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && searchBtnClick()} />
                   
                        {keyword !== "" && 
                            <div className="clear-search" onClick={reset} aria-label='clear search'>x</div>
                        }
                </div>

            </React.Fragment>
    );
};

export default SearchBox;